export enum FormAttributeType {
    Invalid = 0,
    ValidatorName = 1,
    IsReadOnly = 2,
}
